import { type RecordingImage } from './recordingImageApi'

// 表示中の生成物 (SOAP の版・報告書) が読んでも飛ばしてもいない資料の id。生成の後に届いた 1 枚・
// 送り直した 1 枚・📎 で足した 1 枚がここに入る。読んだ id を残していない生成物 (null) では分からないので
// null を返す (古い生成物の資料を全部「入っていない」と言わない)。消した資料は一覧に無いので数えない。
export const unreadAttachmentIds = (
  images: RecordingImage[],
  readIds: string[] | null | undefined,
  skippedIds: string[]
): string[] | null =>
  readIds
    ? images
        .filter(
          (img) => !readIds.includes(img.id) && !skippedIds.includes(img.id)
        )
        .map((img) => img.id)
    : null
